<template>
  <div class="center-loader" v-if="loadRoomInformation">
    <Loader />
  </div>

  <div v-else>
    <div v-if="errorGetRoomInformations">
      <ErrorShootingInformations :authenticated="authenticated" v-on:back-room="backRoom" />
    </div>

    <ChangeNavigatorAlert v-else-if="iOS && !iOSSafari" :room="room" :message="$t('rooms.navigatorAlert.message')" />

    <ChangeNavigatorAlert v-else-if="isIE" :room="room" :message="$t('rooms.navigatorAlert.messageIE')" />

    <ChangeNavigatorAlert
      v-else-if="!iOS && isFacebook"
      :room="room"
      :message="$t('rooms.navigatorAlert.messageFacebook')"
    />

    <PreviewVideoCall
      v-else-if="isPreview"
      :authenticated="authenticated"
      :room="room"
      v-on:join-room="joinRoom"
      v-on:back-room="backRoom"
    />

    <LiveVideoCall v-else-if="isLive" :currentRoom="room" :authenticated="authenticated" v-on:call-end="redirect" />

    <div v-else-if="!isPreview && !isLive">
      <CallEnd :authenticated="authenticated" v-on:join-room="joinRoom" v-on:back-room="backRoom" :room="room" />
    </div>
  </div>
</template>

<script>
import CallEnd from '@/components/liveVideo/CallEnd'
import ChangeNavigatorAlert from '@/components/liveVideo/ChangeNavigatorAlert'
import LiveVideoCall from '@/components/liveVideo/LiveVideoCall'
import Loader from '@/components/Loader'
import PreviewVideoCall from '@/components/liveVideo/PreviewVideoCall'
import ErrorShootingInformations from '@/components/liveVideo/ErrorShootingInformations'

import { mapState } from 'vuex'
import { manageAccessMixin } from '@/mixins/manageAccessMixin.js'

export default {
  components: {
    CallEnd,
    ChangeNavigatorAlert,
    LiveVideoCall,
    Loader,
    PreviewVideoCall,
    ErrorShootingInformations
  },

  mixins: [manageAccessMixin],

  data() {
    return {
      loadRoomInformation: false,
      errorGetRoomInformations: null,
      isPreview: true,
      isLive: false,
      isMobile: null,
      iOSSafari: null,
      iOS: null,
      isIE: null,
      isFacebook: null
    }
  },

  computed: {
    ...mapState({
      roomDevices: state => Object.assign({}, state.roomDevices),
      room: state => state.currentRoom
    })
  },

  async created() {
    this.checkNavigatorAndDevices()

    this.loadRoomInformation = true
    const id_live_video = this.$route.params.idLiveVideo
    const res = await this.getRoomInformations(id_live_video)
    await this.$store.dispatch('shootingOptions', { id: id_live_video, page: 'liveVideoCall' })
    this.loadRoomInformation = false

    if (!res) {
      this.isPreview = false
      this.errorGetRoomInformations = true
    }
  },

  destroyed() {
    this.$store.commit('RESET_LOGO_BRAND')
  },

  methods: {
    joinRoom() {
      this.isPreview = false
      this.isLive = true
    },

    backRoom() {
      this.$router.push('/videos/live/rooms')
    },

    async getRoomInformations(idLiveVideo) {
      return await this.$store.dispatch('getRoomInformations', idLiveVideo)
    },

    redirect() {
      this.isPreview = false
      this.isLive = false
    },

    isFacebookApp() {
      var ua = navigator.userAgent || navigator.vendor || window.opera
      return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1
    },

    checkNavigatorAndDevices() {
      const ua = navigator.userAgent
      const isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      const webkit = !!ua.match(/WebKit/i)
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
      const isMobile = !!ua.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i)
      const isFacebook = this.isFacebookApp()

      this.isIE = isIE
      this.iOS = iOS
      this.iOSSafari = iOSSafari
      this.isMobile = isMobile
      this.isFacebook = isFacebook
    }
  }
}
</script>

<style lang="sass">
.center-loader
  display: flex
  justify-content: center
  margin-top: 25px

/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar
  display: none

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar
  -ms-overflow-style: none
  scrollbar-width: none
</style>
